import { apiService } from './apiService';

const viteEnv = ((import.meta as any)?.env || {}) as Record<string, string | undefined>;

export const bidService = {
  async getAll(filters?: { shipmentId?: string; driverId?: string; status?: string }) {
    const params = new URLSearchParams();
    if (filters?.shipmentId) params.append('shipmentId', filters.shipmentId);
    if (filters?.driverId) params.append('driverId', filters.driverId);
    if (filters?.status) params.append('status', filters.status);
    
    const query = params.toString();
    return await apiService.get(`/bids${query ? `?${query}` : ''}`);
  },

  async create(data: { shipmentId: string; driverId?: string; applicationId?: string; bidAmount: number; notes?: string; driverWorkiomId?: string; tractorPlate?: string; trailerPlate?: string; vehicleType?: string; externalTransportAccountUserId?: string | number; externalTransportActorUserId?: string | number }) {
    return await apiService.post('/bids', {
      shipmentId: data.shipmentId,
      driverId: data.driverId,
      applicationId: data.applicationId,
      bidAmount: data.bidAmount,
      notes: data.notes,
      driverWorkiomId: data.driverWorkiomId,
      tractorPlate: data.tractorPlate,
      trailerPlate: data.trailerPlate,
      vehicleType: data.vehicleType,
      externalTransportAccountUserId: data.externalTransportAccountUserId,
      externalTransportActorUserId: data.externalTransportActorUserId,
    });
  },

  async update(id: string | number, data: { bidAmount: number; notes?: string; driverWorkiomId?: string; tractorPlate?: string; trailerPlate?: string; vehicleType?: string; externalTransportAccountUserId?: string | number; externalTransportActorUserId?: string | number }) {
    return await apiService.put(`/bids/${id}`, data);
  },

  async accept(id: string | number) {
    return await apiService.put(`/bids/${id}/accept`, {});
  },

  async reject(id: string | number, data?: { reason?: string }) {
    return await apiService.put(`/bids/${id}/reject`, data || {});
  },

  // Get bid requests (open shipments for bidding)
  async getBidRequests(filters?: { status?: string; minBudget?: number; maxBudget?: number; shipmentId?: string }) {
    const params = new URLSearchParams();
    if (filters?.status) params.append('status', filters.status);
    if (filters?.minBudget) params.append('minBudget', filters.minBudget.toString());
    if (filters?.maxBudget) params.append('maxBudget', filters.maxBudget.toString());
    if (filters?.shipmentId) params.append('shipmentId', filters.shipmentId);
    
    const query = params.toString();
    return await apiService.get(`/bid-requests${query ? `?${query}` : ''}`);
  },

  // Get bid request details
  async getBidRequest(id: string | number) {
    return await apiService.get(`/bid-requests/${id}`);
  },

  async uploadReferenceWaybill(formData: FormData) {
    const baseUrl = viteEnv.VITE_API_URL || 'http://localhost:5000/api';
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${baseUrl}/documents/upload`, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      body: formData,
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || 'Referans e-irsaliye yuklenemedi');
    }
    return data;
  },

  async createBidRequest(data: any) {
    return await apiService.post('/bid-requests', data);
  },

  async closeBidRequest(id: string | number) {
    return await apiService.put(`/bid-requests/${id}/close`, {});
  },

  async cancelBidRequest(id: string | number) {
    return await apiService.put(`/bid-requests/${id}/cancel`, {});
  },

  async deleteBidRequest(id: string | number) {
    return await apiService.delete(`/bid-requests/${id}`);
  },

  async resetBidRequestsByShipment(shipmentId: string | number) {
    return await apiService.delete(`/bid-requests/shipment/${shipmentId}`);
  },

  async previewEligibleDrivers(lat?: number | null, lon?: number | null) {
    const params = new URLSearchParams();
    if (lat != null && lon != null && lat !== 0 && lon !== 0) {
      params.append('lat', String(lat));
      params.append('lon', String(lon));
    }
    const query = params.toString();
    return await apiService.get(`/bid-requests/eligible-drivers${query ? `?${query}` : ''}`);
  },

  async getExternalDrivers() {
    return await apiService.get('/bid-requests/external-drivers');
  },
};
